import { DeliveryCompanyModel } from '../../delivery_company/models/DeliveryCompanyModel'

export class OrderInvoiceModel {
    id?:number = undefined
    idSource?:number = undefined
    idExternalChannel?:number = undefined
    freightTotal?: number = 0
    issuanceDate?: string = undefined
    invoiceNumber?: number = undefined
    invoiceSeries?: number = undefined
    accessKey?: string = ""
    invoiceUrl?: string = undefined
    trackingCode?: string = ""
    trackingUrl?: string = ""
    xmlUrl?:string = ""
    value?: number = undefined
    deliveryCompany?: DeliveryCompanyModel = undefined
    loadingListAction: boolean = false

    constructor(oi?: Partial<OrderInvoiceModel>) {
        Object.assign(this, oi)

        this._parseDeliveryCompany()
    }

    hasXmlUrl():boolean {
        return !!this.xmlUrl
    }

    hasTrackingUrl():boolean {
        return !!this.trackingUrl
    }

    private _parseDeliveryCompany(): void {
        this.deliveryCompany = new DeliveryCompanyModel(this.deliveryCompany)
    }
}
